import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=a768b87e&scoped=true&"
import script from "./VideoComponent.vue?vue&type=script&lang=js&"
export * from "./VideoComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=a768b87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a768b87e",
  null
  
)

export default component.exports